<!-- Водители верх -->
<div class="tabpage drivers hidden" id="drivers_top">
  <div class="inputgroup">
    <input class="searchinput" type="text" placeholder="{{ 'Find by name'| translate }}" />
  </div>
  <div class="choosegroup dropdown dropclick">
    <input type="text" readonly="readonly" />
    <div class="dropcontent dontclose">
      <div class="dropcontentinset">
        <!-- button class="btnaddgroup">{{ 'Add' | translate }}</button-->
        <input type="text" class="searchinput" placeholder="{{ 'Group search'| translate }}" />
        <ul class="group-filter-list"></ul>
      </div>
    </div>
    <div class="objdropdown dropdown dropclick dropclickjs">
      <ul>
        <li>{{ 'Select' | translate }}</li>
      </ul>
    </div>
  </div>
  <div class="tableheader">
    <input onclick="selectAllLeft(this)" type="checkbox">
    <label class="check_img check_sortaz"><input type="checkbox"><span></span></label>
  </div>
  <div class="tablewrap">
    <div class="table">
      <table id="driverlist">
      </table>
      <div class="objdropdown dropdown dropclick dropclickjs" id="driversmenu">
        <ul>
          <li>{{ 'Show on the map' | translate }}</li>
          <li *ngIf="canAccessComponent(AccessRights.EDIT)" class="separator"></li>
          <li *ngIf="canAccessComponent(AccessRights.EDIT)">{{ 'Edit' | translate }}</li>
          <!--li class="red">{{ 'Delete' | translate }}</li-->
        </ul>
      </div>
    </div>
  </div>
  <app-pagination [viewmode]="'pages hideitemscount'" class="driverspager"></app-pagination>
</div>

<template #mgmtDialog></template>
<template #groupMgmtDialog></template>
